import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import Vue from 'vue';
import { WPSClientErr } from '@kso/ui/lib/config/error';
import isEmpty from 'lodash/isEmpty';
import { isServerRendering, csrfToken, parseUrl } from '@kso/util';
import '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { replaceLocHost, ACCOUNT, DOCS, DRIVE, PLUSSVR, PLUS, STORE, WOA, FILECOLLECT, SECURITYDOC, KDOCS, TWPS, PUB, YUNAPI, RILI, WEBOFFICE, MSGCENTER, VIPAPI, PAYCONFIGAPI, PAYAPI, VAS, GEOACCOUNT, getOrigin, WPSPLUS, APIWPS } from '@kso/constants';
import axios from '@kso/axios';
import Message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import csrftoken from '@kso/axios/interceptors/csrftoken';
import proxy2K3rd from '@kso/axios/interceptors/proxy2K3rd';
import exception from '@kso/axios/interceptors/exception';
import login from '@kso/axios/interceptors/login';
import get from 'lodash/get';
import { globalData } from '@kso/ui/lib/utils/globalData';
import { PlugCtr } from '@ecis/plugctr';
import settle from 'axios/lib/core/settle';
import '@kso/ui/lib/utils/sideEffect';
import 'lodash/chunk';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@kso/ui/lib/config/locale';
import '@kso/ui/lib/utils/error';
import '@babel/runtime/helpers/typeof';
import '@wps/wps_client_api/network';
import '@wps/wps_client_api/account';
import cookie from 'cookie';
import '@kso/vue-shield-config';

/* eslint-disable */
var fromCharCode = String.fromCharCode;

// encoder stuff
var cb_utob = function cb_utob(c) {
  if (c.length < 2) {
    var cc = c.charCodeAt(0);
    return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
  } else {
    var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
    return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
  }
};
var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
var utob = function utob(u) {
  return u.replace(re_utob, cb_utob);
};
var _encode = function _encode(u) {
  return window.btoa(utob(u));
};
var encode = function encode(u, urisafe) {
  return !urisafe ? _encode(String(u)) : _encode(String(u)).replace(/[+\/]/g, function (m0) {
    return m0 == '+' ? '-' : '_';
  }).replace(/=/g, '');
};

// decoder stuff
var re_btou = new RegExp(['[\xC0-\xDF][\x80-\xBF]', '[\xE0-\xEF][\x80-\xBF]{2}', '[\xF0-\xF7][\x80-\xBF]{3}'].join('|'), 'g');
var cb_btou = function cb_btou(cccc) {
  switch (cccc.length) {
    case 4:
      var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3),
        offset = cp - 0x10000;
      return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
    case 3:
      return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
    default:
      return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
  }
};
var btou = function btou(b) {
  return b.replace(re_btou, cb_btou);
};
var _decode = function _decode(a) {
  return btou(window.atob(a));
};
var decode = function decode(a) {
  return _decode(String(a).replace(/[-_]/g, function (m0) {
    return m0 == '-' ? '+' : '/';
  }).replace(/[^A-Za-z0-9\+\/]/g, ''));
};
var Base64 = {
  encode: encode,
  decode: decode
};

// 不需要kso/axios默认错误toast提示的正则列表
var slientList = [/api\/report/, /contacts\/recommend/, /v5\/companies/, /v3\/groups\/\d+\/role_members/, /v3\/search\/company\/\d+\/members/, /v3\/search\/groups\/\d+\/members/, /company\/\d+\/detail/, /api\/\d+\/department\/curlevel/, /api\/\d+\/dept\/users/, /app\/job\/v1\/syncuser\/companies/, /api\/contact\/relation/, /api\/v5\/corpgroups\/corpindex/, /api\/user\/userinfo/, /api\/v3\/links\/\d+\?include=members/];

/* ECIS start */
var plugctr = new PlugCtr('kso');
/* ECIS end */

var account = {
  account: {
    '/api/certification': {
      methods: {
        get: function get() {
          return {
            certification: 1,
            need_verify: true,
            phone: '***',
            result: 'ok'
          };
        }
      }
    }
  }
};

var drive = {
  drive: {
    '/api/v3/groups/secret': {
      methods: {
        'get': function get() {
          return {};
        }
      }
    },
    '/api/v5/corpgroups/corpindex': {
      methods: {
        'get': function get() {
          return {
            id: 0
          };
        }
      }
    },
    '/api/v3/groups/0/members': {
      methods: {
        'get': function get() {
          return {};
        }
      }
    },
    '/api/v3/groups/special': {
      methods: {
        'get': function get() {
          return {
            corpid: 0,
            creator: {},
            ctime: 0,
            default_type: 'None',
            event_alert: 1,
            group_type: 'special',
            id: 0,
            member_count: 1,
            member_count_limit: 1,
            mtime: 0,
            name: '我的云文档',
            secure: false,
            type: 'special',
            user_role: 'creator'
          };
        }
      },
      version: ['oem']
    },
    '/api/v5/groups/special/files': {
      methods: {
        'get': function get() {
          return {
            next_filter: 'file',
            next_offset: 10,
            result: 'ok',
            files: []
          };
        }
      }
    }
  }
};

function kdocsResponse(data) {
  return {
    code: 0,
    data: data || {}
  };
}
var kdocs = {
  kdocs: {
    '/kd/api/user/config': {
      methods: {
        get: function get(params) {
          var _ref = params || {},
            key = _ref.key;
          var maps = {
            companyHelperGuide: {
              status: 1
            },
            corpIndexMemberGuide: {
              status: 0
            },
            teamMemberReadOnlyGuide: {
              status: 0
            },
            shareGuide: {
              status: 1
            },
            spaceFull: {
              value: ''
            },
            jinxiaomenghello: {
              status: 1
            }
          };
          return kdocsResponse(key ? maps[key] : {
            status: 0
          });
        },
        post: function post() {
          return kdocsResponse({
            result: 'ok'
          });
        }
      }
    },
    '/kdg/api/v1/cards/type/\\d+': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': null
          };
        }
      }
    },
    '/kdg/api/v1/user/setting': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'isShowedPcTeamGuide': false,
              'isShowedKnowledgeTreeSortGuide': false,
              'isShowedKnowledgeTreeGuide': false,
              'isShowedKnowledgeHistoryDataGuide': false,
              'isShowedTextSwitchGuide': true,
              'isShowedTextEntryClick': true,
              'isShowedTextOpenClick': true,
              'isEnabledFp': false,
              'isEnabledDBSheet': false,
              'isSaveOnTable': false,
              'isSaveOnPWA': true,
              'isEnabledPersonalTeam': true,
              'isShowedFulltextCommentCloseTip': false,
              'isShowChangeFrameworkEntNoviceGuidance': true,
              'isSettingCommonAsLabel': false,
              'isCommonUnfold': true,
              'isLabelUnfold': true,
              'isSkippedBindingMobile': false
            }
          };
        },
        'put': function put() {
          return {
            'code': 0,
            'result': 'OK'
          };
        }
      }
    },
    '/kdteam/api/v1/team/\\d+': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'sources': ['yundoc']
            }
          };
        }
      }
    },
    '/api/kdocs/file/\\d+/application/editing': {
      methods: {
        'get': function get() {
          return {
            'allow_apply_edit': 1
          };
        }
      }
    },
    '/kd/api/wenjuan/user': {
      methods: {
        'get': function get() {
          return kdocsResponse({
            'questionnaire': null
          });
        }
      }
    },
    '/kdg/api/v1/cards/king-skin': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'kingSkinCard': {
                'data': '',
                'id': 'jinxiaomeng',
                'name': 'jinxiaomeng',
                'type': 20
              }
            }
          };
        }
      }
    },
    '/kdg/api/v1/file/creator/\\d+': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'creator': 238660632,
              'ctime': 1627436854,
              'username': '超级管理员1',
              'avatar': 'https://imagebucket.test.wpscdn.cn/238660632_143685c0f7d3c42d6ae5b23672f35d8b?imageMogr2/thumbnail/180x180!'
            }
          };
        }
      }
    },
    '/kdg/api/v1/configure': {
      methods: {
        'get': function get(params) {
          var idList = '';
          if (typeof params === 'string') {
            idList = params.split('=')[1];
          } else {
            idList = params.idList;
          }
          var maps = {
            forbidSider: {
              forbidSider: 1
            },
            messagecenterv2: {
              messagecenterv2: 0
            },
            inboxSwitch: {
              inboxSwitch: null
            },
            fullTextCommentConfig: {
              fullTextCommentConfig: '{"supports": "wps,otl","autoOnWhenCreated": "","autoOnWhenShared": "wps,otl"}'
            },
            skippedBindingMobile: {
              skippedBindingMobile: false
            }
          };
          return {
            'code': 0,
            'result': 'OK',
            'data': maps[idList]
          };
        }
      }
    },
    '/wx_adapter/v1/mp/subscribe/vip_zcgl': {
      methods: {
        'get': function get() {
          return {
            'data': {
              'subscribe_time': '1626838792'
            },
            'msg': 'subscribed',
            'result': 'ok'
          };
        }
      }
    },
    '/kdg/api/v1/params/baseOperation/sub_keys': {
      methods: {
        'get': function get(params) {
          var subKeys = '';
          if (typeof params === 'string') {
            subKeys = params.split('=')[1];
          } else {
            subKeys = params.subKeys;
          }
          var maps = {
            keyboard_move: {
              'keyboard_move': {
                'keyboard_move': 1
              }
            }
          };
          return {
            'code': 0,
            'result': 'OK',
            'data': maps[subKeys]
          };
        }
      }
    },
    '/kdg/api/v1/params/square/sub_keys': {
      methods: {
        'get': function get(params) {
          var subKeys = '';
          if (typeof params === 'string') {
            subKeys = params.split('=')[1];
          } else {
            subKeys = params.subKeys;
          }
          var maps = {
            wechatApplyEdit: {}
          };
          return {
            'code': 0,
            'result': 'OK',
            'data': maps[subKeys]
          };
        }
      }
    },
    '/kdg/api/v1/square/event/check': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'isSquareDoc': false
            }
          };
        }
      }
    }
  }
};

var plus = {
  plus: {
    "/ops/opsd/api/v1/policy": {
      methods: {
        get: function get() {
          return {
            data: [],
            debug: {
              entity_model: null
            },
            policy_id: 0,
            policy_name: "",
            task_id: 0,
            total: 0
          };
        }
      }
    },
    "/app/groupext/v1/template/groups": {
      methods: {
        get: function get() {
          return {
            data: []
          };
        }
      }
    }
  }
};

var plussvr = {
  plussvr: {
    "/compose/api/v1/companies/\\d+/enterprise_info": {
      methods: {
        get: function get() {
          return {};
        }
      }
    },
    "/api/company": {
      methods: {
        get: function get() {
          return {
            companies: [],
            result: "ok"
          };
        }
      },
      version: ["oversea"]
    },
    "/api/user/userinfo": {
      methods: {
        get: function get() {
          return {
            userinfo: {},
            result: "ok"
          };
        }
      },
      version: ["oversea"]
    },
    '/sysadmin/strategy/v1/sys/me/guides/positions': {
      methods: {
        'get': function get() {
          return {
            data: []
          };
        }
      }
    }
  }
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var unsupportApis = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, account), drive), kdocs), plus), plussvr);

/**
 * 创建通用的请求工厂函数
 *
 */
axios.defaults.withCredentials = true;
var target$2 = typeof window === 'undefined' ? global : window;
var envr = target$2 && target$2.__KD_CONFIG__ && target$2.__KD_CONFIG__.props && target$2.__KD_CONFIG__.props.release === 'oem';
var LOGIN_ACCESS_ID = process.env.KAE_LOGIN_ACCESSID;
function createInstance(options) {
  var tK3rd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var request = axios.create(options);
  if (!isServerRendering()) {
    if (!options.clear) {
      request.addInjector(csrftoken);
      tK3rd && request.addInjector(proxy2K3rd);
    }
    request.addInjector(exception, Message, {
      exclude: function exclude(error) {
        return slientList.some(function (regex) {
          return regex.test(get(error, 'response.request.responseURL', ''));
        });
      }
    });
    request.addInjector(login, function () {
      if (!globalData.unLoginRedirect) {
        return;
      }
      var url = "".concat(ACCOUNT, "?cb=").concat(encodeURIComponent(window.location.href));
      if (LOGIN_ACCESS_ID) {
        url = "".concat(ACCOUNT, "?accessid=").concat(LOGIN_ACCESS_ID, "&cb=").concat(encodeURIComponent(window.location.href));
      }
      window.location.replace(url);
    });
    request.interceptors.request.use(function (config) {
      // 如果存在自定义 path，则加入拦截器，根据当前域名以及自定义的 path 拼接请求的 baseURL
      if (window.$ksoui_customProxyPath) {
        var baseURL = config.baseURL;
        var baseHost = baseURL.match(/(\w+)\.wps\.cn/)[1];
        config.baseURL = replaceLocHost("".concat(window.$ksoui_customProxyPath, "/").concat(baseHost));
      }
      return config;
    });
    if (envr) {
      request.interceptors.request.use(requestMockIntercept);
    }
  }

  /* ECIS start */
  /* @Description: 定制统一接口拦截 */
  var ecisFlag = request.interceptors.request.handlers && request.interceptors.request.handlers.find(function (item) {
    return item.fulfilled && item.fulfilled.ecisInterceptor;
  });
  if (!ecisFlag) {
    var ecisReqFn = function ecisReqInterceptor(config) {
      return plugctr.ask('request', config, config);
    };
    ecisReqFn.ecisInterceptor = true;
    var ecisUse = request.interceptors.request.use;
    request.interceptors.request.use = function () {
      var _this = this;
      var ecisFn = null;
      if (request.interceptors.request && request.interceptors.request.handlers && request.interceptors.request.handlers.length > 0) {
        var ecisIdx = request.interceptors.request.handlers.findIndex(function (t) {
          return t.fulfilled && t.fulfilled.ecisInterceptor;
        });
        if (ecisIdx > -1) {
          ecisFn = request.interceptors.request.handlers.splice(ecisIdx, 1)[0];
        }
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var result = ecisUse.call.apply(ecisUse, [_this].concat(args));
      if (ecisFn && !(args && args[0] && args[0].ecisInterceptor)) {
        request.interceptors.request.handlers.push(ecisFn);
      }
      return result;
    };
    request.interceptors.request.use(ecisReqFn);
  }
  var ecisFlagRes = request.interceptors.response.handlers && request.interceptors.response.handlers.find(function (item) {
    return item.fulfilled && item.fulfilled.ecisInterceptor;
  });
  if (!ecisFlagRes) {
    var ecisResFn = function ecisResInterceptor(config) {
      return plugctr.ask('response', config, config);
    };
    ecisResFn.ecisInterceptor = true;
    request.interceptors.response.use(ecisResFn);
  }
  /* ECIS end */

  return request;
}
function requestMockIntercept(conf) {
  var release = window.__KD_ENCRYPTION_CONFIG__.release;
  if (release && !conf.$$mock) {
    var method = conf.method,
      params = conf.params,
      url = conf.url;
    var mockData = null;
    Object.keys(unsupportApis).forEach(function (appname) {
      var apis = Object.keys(unsupportApis[appname]);
      apis.forEach(function (api) {
        var _unsupportApis$appnam = unsupportApis[appname][api],
          methods = _unsupportApis$appnam.methods,
          version = _unsupportApis$appnam.version;
        if (version && ~version.indexOf(release) || version === undefined) {
          // 因为私有化会有gateway的path, 转换成正则
          Object.keys(methods).forEach(function (_method) {
            var getter = methods[_method];
            var reg = new RegExp(api.replace(new RegExp('/', 'g'), '\\/'));
            _method = _method.toLowerCase();
            if (method.toUpperCase() === _method.toUpperCase() && reg.test(url)) {
              var query = method === 'get' && params || conf.data || url.split('?')[1];
              mockData = getter(query);
            }
          });
        }
      });
    });
    if (mockData) {
      conf.adapter = function () {
        return new Promise(function (resolve, reject) {
          settle(resolve, reject, {
            status: 200,
            statusText: 'OK',
            data: mockData,
            config: conf,
            headers: {
              status: 200,
              statusText: 'OK'
            },
            request: {
              fromCache: true
            }
          });
        });
      };
      conf.xMocked = true;
    }
    conf.$$mock = true;
  }
  return conf;
}

createInstance({
  baseURL: ACCOUNT,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});
createInstance({
  baseURL: DRIVE,
  withCredentials: true,
  timeout: 30000
});

axios.CancelToken;
var request$1 = createInstance({
  baseURL: DRIVE,
  withCredentials: true
});
createInstance({
  baseURL: DOCS,
  withCredentials: true
});
var createUserRedirect = /*#__PURE__*/function () {
  var _ref97 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(url) {
    var _yield$request$post11, data;
    return _regeneratorRuntime.wrap(function _callee89$(_context89) {
      while (1) switch (_context89.prev = _context89.next) {
        case 0:
          _context89.next = 2;
          return request$1.post('/api/users/redirect', {
            cb: url
          });
        case 2:
          _yield$request$post11 = _context89.sent;
          data = _yield$request$post11.data;
          return _context89.abrupt("return", data);
        case 5:
        case "end":
          return _context89.stop();
      }
    }, _callee89);
  }));
  return function createUserRedirect(_x136) {
    return _ref97.apply(this, arguments);
  };
}();

createInstance({
  baseURL: PLUSSVR,
  withCredentials: true
});

var request = createInstance({
  baseURL: PLUS,
  withCredentials: true
});

// 获取权限回收任务转态 "not_exist" "fiting" "finish"
(function () {
  try {
    var statusMap = {
      not_exist: undefined,
      fiting: true,
      finish: false
    };
    return /*#__PURE__*/function () {
      var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(groupId) {
        var _yield$request$get23, data;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return request.get("/drive/v1/admin/groups/".concat(groupId, "/fit/taskinfo"));
            case 2:
              _yield$request$get23 = _context33.sent;
              data = _yield$request$get23.data;
              return _context33.abrupt("return", statusMap[data.status] || statusMap.finish);
            case 5:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }));
      return function (_x34) {
        return _ref37.apply(this, arguments);
      };
    }();
  } catch (e) {
    return false;
  }
})();

createInstance({
  baseURL: PLUS,
  withCredentials: true,
  notTransformBaseUrl: false
});

// import axios from '@kso/axios'

// const CancelToken = axios.CancelToken
createInstance({
  baseURL: DRIVE,
  withCredentials: true
});

var target$1 = typeof window === 'undefined' ? global : window;
target$1 && target$1.__KD_CONFIG__ && target$1.__KD_CONFIG__.props && target$1.__KD_CONFIG__.props.release === 'oem';
createInstance({
  baseURL: DRIVE,
  withCredentials: true
});
createInstance({
  baseURL: DOCS,
  withCredentials: true
});

function getCookie(name) {
  var rawcookie = {};
  if (typeof document !== 'undefined') {
    if (document && document.cookie) {
      rawcookie = cookie.parse(document.cookie);
      return rawcookie[name] || null;
    }
  }
  return null;
}
getCookie('csrf') || csrfToken();

var target = typeof window === 'undefined' ? global : window;
target && target.__KD_CONFIG__ && target.__KD_CONFIG__.props && target.__KD_CONFIG__.props.release === 'oem';
createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: STORE,
  withCredentials: true
});

createInstance({
  baseURL: ACCOUNT,
  withCredentials: true,
  timeout: 30000
}, false);

createInstance({
  baseURL: WOA,
  withCredentials: true,
  timeout: 30000
});
createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: FILECOLLECT,
  withCredentials: true
});

createInstance({
  baseURL: SECURITYDOC,
  withCredentials: true
});

createInstance({
  baseURL: PLUS,
  withCredentials: true
});
createInstance({
  baseURL: DRIVE,
  withCredentials: true
});
createInstance({
  baseURL: DOCS,
  withCredentials: true
});
createInstance({
  baseURL: KDOCS,
  withCredentials: true
});

createInstance({
  baseURL: PLUS,
  withCredentials: true,
  onUploadProgress: function onUploadProgress(p) {
    return 100 * (p.loaded / p.total);
  }
});

createInstance({
  baseURL: TWPS,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: KDOCS,
  withCredentials: true,
  timeout: 30000
});

// const {getUA} = require('@kso/util')

createInstance({
  baseURL: PUB,
  withCredentials: true,
  timeout: 30000
});
createInstance({
  baseURL: YUNAPI,
  withCredentials: true,
  timeout: 30000
});

// const {getUA} = require('@kso/util')

createInstance({
  baseURL: PUB,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: RILI,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: WEBOFFICE,
  withCredentials: true
});

createInstance({
  baseURL: MSGCENTER,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: VIPAPI,
  withCredentials: true,
  timeout: 30000
});

var _ref = typeof document !== 'undefined' ? document && cookie.parse(document.cookie) : {},
  deviceId = _ref.weboffice_device_id;
createInstance({
  baseURL: WEBOFFICE,
  withCredentials: true,
  headers: {
    'Client-Type': 'kdocs-web',
    'Account-Deviceid': deviceId || ''
  },
  device_id: deviceId,
  timeout: 10000
});

createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: PAYCONFIGAPI,
  withCredentials: true
});

createInstance({
  baseURL: PAYAPI,
  withCredentials: true
});

/**
 * VAS于axios已配置双域名, 但是测试环境没有对应的wps.cn域名，所以在测试环境wps.cn域名下要测试VAS接口，只能写死为kdocs
 * const VAS = 'https://vas-api.kdocs.cn'
 */

createInstance({
  baseURL: VAS,
  withCredentials: true,
  timeout: 5000
});

createInstance({
  baseURL: GEOACCOUNT,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: getOrigin('vas2t'),
  withCredentials: true,
  timeout: 5000
});

createInstance({
  baseURL: WPSPLUS,
  withCredentials: true,
  timeout: 5000
});

createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});

createInstance({
  baseURL: KDOCS,
  withCredentials: true
});

createInstance({
  baseURL: APIWPS,
  withCredentials: true
});

/**
 * x-verification token 存储方案
 * 统一存储到 X_VERIFICATION_TOKEN_STORAGE_KEY 下，保存值为一个对象
 * 该对象为请求的标识与 token 的键值对，如何计算请求标识？
 * 请求路径（不包括 url query）与方法组成
 * 如果请求路径与方法均相同，则认为是同一个请求
 */

function combineURL() {
  var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var relativeURL = arguments.length > 1 ? arguments[1] : undefined;
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
var KEY = {
  X_VERIFICATION_TOKEN: 'X_VERIFICATION_TOKEN'
};
/**
 * @param {{ url: string, baseURL: string, method: string}} config
 */
function getRequestId(config) {
  var _config$method = config.method,
    method = _config$method === void 0 ? '' : _config$method,
    baseURL = config.baseURL,
    url = config.url;
  // 目前使用的 axios 版本没有 getUri 方法
  var entireURL = isAbsoluteURL(url) ? url : combineURL(baseURL, url);
  var index = entireURL.indexOf('?');
  var filteredURL = index === -1 ? entireURL : entireURL.substring(0, index);
  return "".concat(method.toUpperCase(), ":").concat(filteredURL);
}

/**
 * @param {{ url: string, baseURL: string, method: string}} config
 * @returns {string | undefined}
 */
function getXVerificationToken(config) {
  var allTokens = JSON.parse(localStorage.getItem(KEY.X_VERIFICATION_TOKEN) || '{}');
  var requestId = getRequestId(config);
  return allTokens[requestId];
}

var xVerificationHeaderName = 'X-Verifications';
createInstance({
  baseURL: PLUS,
  withCredentials: true,
  timeout: 5000
});
var xVerificationRequest = createInstance({
  baseURL: PLUS,
  withCredentials: true,
  timeout: 5000
});
xVerificationRequest.interceptors.request.use(function (config) {
  var _ref = config.xVerifications || {},
    isXVerificationsEnabled = _ref.enabled;
  if (isXVerificationsEnabled && !config.headers[xVerificationHeaderName]) {
    var token = getXVerificationToken(config);
    var headerValue = "Check-Code ".concat(btoa("".concat(token, ":")));
    config.headers[xVerificationHeaderName] = headerValue;
  }
  return config;
});

function invoke(query) {
  var _window = window,
    cefQuery = _window.cefQuery,
    clientAPI = _window.clientAPI,
    homepageapiasync = _window.homepageapiasync,
    wpsQuery = _window.wpsQuery;
  var Q = cefQuery || window.top.cefQuery || clientAPI || homepageapiasync || wpsQuery;
  var api = query.api,
    callback = query.callback,
    method = query.method,
    params = query.params;
  return new Promise(function (resolve, reject) {
    if (api === 'postMessage') {
      Array.isArray(params) && params.push(callback);
      if (window.top && window.top.postMessage) {
        window.top.postMessage(JSON.stringify({
          id: callback,
          method: method,
          params: params // 跟客户端沟通后，params 按数组传值
        }), '*');
      }
    } else if (Q) {
      var q = JSON.stringify(query);
      var _api = 'jsAsynCall';
      var _q = Object.assign({}, query);
      if (_q.api === 'fromJSAsynCallBase64') {
        _api = _q.api;
        delete _q.api;
        q = Base64.encode(JSON.stringify(_q));
      }
      var invokeQuery = {
        request: "".concat(_api, "('").concat(q, "')"),
        persistent: false,
        onSuccess: function onSuccess(res) {
          if (_q.method === 'openFile') {
            if (_q.type && _q.type === 'web_open_client') {
              call({
                method: 'closeDialog',
                api: 'fromJSAsynCallBase64'
              })["catch"](function () {});
            } else {
              // openFile 客户端没执行前端在window下注册的callback，前端兜底执行
              var WIN = getWinObj();
              if (WIN[callback]) {
                WIN[callback](res);
              }
            }
          }
          resolve('invoke success');
        },
        onFailure: function onFailure(code, msg) {
          reject(WPSClientErr({
            result: msg,
            code: 'apiUnsupport'
          }));
        }
      };

      // QT
      if ('jsAsynCall' in Q) {
        Q = Q.jsAsynCall;
        invokeQuery = q;
      }
      console.log('Orgin Query:', query);
      console.log('invoke Query:', invokeQuery);
      var st = "request: ".concat(_api, "('").concat(q, "')");
      console.log('st=>', st);
      try {
        Q(invokeQuery);
      } catch (e) {
        console.log(e);
      }
      resolve(true);
    } else {
      reject(WPSClientErr({
        code: 'apiUnsupport'
      }));
    }
  });
}

/**
 * 如果 window.top 存在并且不为空返回 window.top，否则返回 window 对象
 * 兼容 2016 2018
 * @param none
 * @returns {Window}
 */
var getWinObj = function () {
  var WIN;
  function win() {
    if (WIN) {
      return WIN;
    } else {
      // 2018 版本跨域调用 top 直接报错
      try {
        var _ref = window.__UA__ || {},
          WPS = _ref.WPS,
          wps2016 = _ref.wps2016;
        if (WPS && !wps2016) {
          WIN = window;
          return WIN;
        }
        WIN = window.top;
      } catch (e) {
        WIN = window;
      }
      if (!isEmpty(WIN)) {
        return WIN;
      }
      // 2016 版本跨域调用 top 返回空对象
      if (!!window.top && !isEmpty(window.top)) {
        WIN = window.top;
      } else {
        WIN = window;
      }
      return WIN;
    }
  }
  return win;
}();
function call(query) {
  var method = query.method,
    callback = query.callback;
  var random = Math.floor(Math.random() * 100000000);
  callback = callback || "CEF_CALLBACK_".concat(method.replace(/\./g, '_').toUpperCase(), "_").concat(random);
  return new Promise(function (resolve, reject) {
    var tmr = null;
    var WIN = getWinObj();
    WIN[callback] = function (result) {
      !query.keepWait && clearTimeout(tmr);
      try {
        var r = JSON.parse(result);
        if (r.callstatus === 'error') {
          reject(r);
        } else {
          resolve(r);
        }
      } catch (e) {
        resolve(result);
      }
      WIN[callback] = function () {};
    };
    if (!query.keepWait) {
      tmr = setTimeout(function () {
        reject(WPSClientErr({
          code: 'apiUnsupport',
          timeout: true
        }));
      }, 1500);
    }
    return invoke(Object.assign({
      callback: callback
    }, query))["catch"](function (e) {
      return reject(e);
    });
  });
}
(function registListener() {
  !Vue.prototype.$isServer && window.addEventListener('message', function (event) {
    // 接口返回字符串判断
    if (typeof event.data !== 'string') {
      return;
    }
    try {
      var data = JSON.parse(event.data);
      var WIN = getWinObj();
      if (data.type === 'callback' && WIN[data.name]) {
        WIN[data.name](JSON.stringify(data.result));
        WIN[data.name] = function () {};
      }
    } catch (e) {
      console.log(e);
    }
  }, false);
})();

/**
 * 查询当前客户端的网络连接状态
 *
 */
var network = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref3, IS_WPS_DRIVER, IS_WPS_WIDGET, method, resp;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref3 = window.__UA__ || {}, IS_WPS_DRIVER = _ref3.IS_WPS_DRIVER, IS_WPS_WIDGET = _ref3.IS_WPS_WIDGET;
          method = IS_WPS_DRIVER && 'checkNetwork' || 'networkStateChanged';
          _context.prev = 2;
          _context.next = 5;
          return call({
            method: method
          });
        case 5:
          resp = _context.sent;
          if (!IS_WPS_DRIVER) {
            _context.next = 10;
            break;
          }
          if (!(resp.status !== 'true')) {
            _context.next = 10;
            break;
          }
          _context.next = 10;
          return call({
            method: 'showOfflinePage'
          });
        case 10:
          if (!IS_WPS_WIDGET) {
            _context.next = 14;
            break;
          }
          if (resp) {
            _context.next = 14;
            break;
          }
          _context.next = 14;
          return call({
            method: 'showOfflinePage'
          });
        case 14:
          _context.next = 19;
          break;
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](2);
          console.log(_context.t0);
        case 19:
          return _context.abrupt("return", resp);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 16]]);
  }));
  return function network() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * 判断客户端浏览器类型
 *
 */
var browserApi = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$call, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return call({
            method: 'common.util.getBrowserInfo'
          });
        case 3:
          _yield$call = _context2.sent;
          result = _yield$call.result;
          return _context2.abrupt("return", result === 'ok');
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return function browserApi() {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * 调起系统的默认浏览器并打开指定的url
 *
 */
var link = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
    var _ref6,
      dest,
      fname,
      ext,
      isOpenWithATag,
      _parseUrl,
      host,
      _yield$createUserRedi,
      data,
      _yield$call2,
      result,
      callstatus,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, dest = _ref6.dest, fname = _ref6.fname, ext = _ref6.ext, isOpenWithATag = _ref6.isOpenWithATag;
          if (/^(\/\/).+$/.test(url)) {
            url = "".concat(window.location.protocol).concat(url);
          } else if (/^(\/).+$/.test(url)) {
            url = "".concat(window.location.protocol, "//").concat(location.host).concat(url);
          }
          _parseUrl = parseUrl(url, 'strict'), host = _parseUrl.host; // yun core 的尝试
          _context3.prev = 3;
          if (!(window.__UA__.yun && !window.__UA__.WPS && (~host.indexOf('wps.cn') || ~host.indexOf('kdocs.cn')))) {
            _context3.next = 12;
            break;
          }
          if (!isOpenWithATag) {
            _context3.next = 9;
            break;
          }
          return _context3.abrupt("return", openUrlWithATag(url));
        case 9:
          if (!window.__UA__.isTabletClient) {
            _context3.next = 11;
            break;
          }
          return _context3.abrupt("return", window.open(url, {
            fname: fname,
            ext: ext
          }));
        case 11:
          return _context3.abrupt("return", window.open(url, '_blank'));
        case 12:
          _context3.next = 16;
          break;
        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](3);
        case 16:
          if (!(host && ~host.indexOf('wps.cn'))) {
            _context3.next = 27;
            break;
          }
          _context3.prev = 17;
          _context3.next = 20;
          return createUserRedirect({
            cb: url
          });
        case 20:
          _yield$createUserRedi = _context3.sent;
          data = _yield$createUserRedi.data;
          url = data.url;
          _context3.next = 27;
          break;
        case 25:
          _context3.prev = 25;
          _context3.t1 = _context3["catch"](17);
        case 27:
          if (!isOpenWithATag) {
            _context3.next = 31;
            break;
          }
          return _context3.abrupt("return", openUrlWithATag(url));
        case 31:
          if (!(window.__UA__.WPS && !(window.__UA__.wps2016 || window.__UA__.wps2018beta))) {
            _context3.next = 62;
            break;
          }
          _context3.prev = 32;
          _context3.next = 35;
          return call({
            method: 'common.util.support',
            params: {
              api: 'openFileByCloud'
            }
          });
        case 35:
          _yield$call2 = _context3.sent;
          result = _yield$call2.result;
          callstatus = _yield$call2.callstatus;
          if (!(result && callstatus === 'ok' && ~host.indexOf('kdocs.cn'))) {
            _context3.next = 44;
            break;
          }
          _context3.next = 41;
          return call({
            method: 'openFileByCloud',
            openUrl: url
          });
        case 41:
          return _context3.abrupt("return", _context3.sent);
        case 44:
          if (!dest) {
            _context3.next = 50;
            break;
          }
          _context3.next = 47;
          return call({
            method: 'common.util.openInnerUrl',
            params: {
              url: url
            }
          });
        case 47:
          return _context3.abrupt("return", _context3.sent);
        case 50:
          _context3.next = 52;
          return call({
            method: 'common.util.openUrl',
            params: {
              url: url
            }
          });
        case 52:
          return _context3.abrupt("return", _context3.sent);
        case 53:
          _context3.next = 60;
          break;
        case 55:
          _context3.prev = 55;
          _context3.t2 = _context3["catch"](32);
          if (!_context3.t2.timeout) {
            _context3.next = 59;
            break;
          }
          return _context3.abrupt("return");
        case 59:
          return _context3.abrupt("return", window.open(url, '_blank'));
        case 60:
          _context3.next = 72;
          break;
        case 62:
          _context3.prev = 62;
          _context3.next = 65;
          return Promise.all([call({
            method: 'openUrl',
            url: url
          }), call({
            method: 'openUrl',
            api: 'postMessage',
            params: [url]
          })]);
        case 65:
          _context3.next = 72;
          break;
        case 67:
          _context3.prev = 67;
          _context3.t3 = _context3["catch"](62);
          if (!_context3.t3.timeout) {
            _context3.next = 71;
            break;
          }
          return _context3.abrupt("return");
        case 71:
          return _context3.abrupt("return", window.open(url, '_blank'));
        case 72:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 14], [17, 25], [32, 55], [62, 67]]);
  }));
  return function link(_x) {
    return _ref5.apply(this, arguments);
  };
}();
function openUrlWithATag(url) {
  var isSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!url) {
    return;
  }
  var a = document.createElement('a');
  a.target = isSelf ? '_self' : '_blank';
  a.ref = 'noreferrer';
  a.href = url;
  a.click();
}

/**
 * 获取客户端版本
 *
 */
var wpsVersion = null;
var getWpsVersion = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!wpsVersion) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", wpsVersion);
        case 2:
          _context4.prev = 2;
          _context4.next = 5;
          return call({
            method: 'getWpsVersionInfo'
          });
        case 5:
          return _context4.abrupt("return", _context4.sent);
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](2);
        case 10:
          _context4.prev = 10;
          _context4.next = 13;
          return call({
            method: 'common.wpsoffice.getAppInfo',
            params: {}
          });
        case 13:
          res = _context4.sent;
          wpsVersion = Object.prototype.toString.call(res) === '[object Object]' ? res : JSON.parse(res);
          return _context4.abrupt("return", wpsVersion);
        case 18:
          _context4.prev = 18;
          _context4.t1 = _context4["catch"](10);
        case 20:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 8], [10, 18]]);
  }));
  return function getWpsVersion() {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * 比较客户端版本
 * A大于等于B
 */
var compareWpsVersion = function compareWpsVersion(versionA, versionB) {
  var arrayA = versionA ? versionA.split('.') : [];
  var arrayB = versionB ? versionB.split('.') : [];
  var maxLen = Math.max(arrayA.length, arrayB.length);
  for (var i = 0; i < maxLen; i++) {
    var a = arrayA[i] ? parseInt(arrayA[i]) : 0;
    var b = arrayB[i] ? parseInt(arrayB[i]) : 0;
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }
  }
  return 0;
};

export { browserApi, call, compareWpsVersion, getWpsVersion, invoke, link, network };
